import { SearchResponseDto } from '@/models/Dtos/common/searchResultDto';
import { RecruitingFlightChiefTableData } from './RecruitingFlightChiefTableData';
import { TableDataProvider } from '../../models/TableDataProvider';
import { Staff } from '@/models/Entities/Personas/Staff';
import { SearchStaffDto } from '@/models/Dtos/searchStaffDto';

export class RecruitingFlightChiefDataProvider extends TableDataProvider<
  RecruitingFlightChiefTableData,
  Staff,
  SearchStaffDto
> {
  protected transformer = (t: Staff): RecruitingFlightChiefTableData =>
    new RecruitingFlightChiefTableData(t);

  protected queryHandler = async (
    searchDto: SearchStaffDto
  ): Promise<SearchResponseDto<Staff>> => {
    const results: SearchResponseDto<Staff> = await this.store.dispatch(
      'recruiterModule/fetchWithSelectParameters',
      searchDto
    );
    return results;
  };
}
